var map = {
	"./Alarm.svg": 84524,
	"./Arrow Left.svg": 31082,
	"./Bulletin.svg": 46727,
	"./Chevron-Left.svg": 75292,
	"./Chevron-down.svg": 16039,
	"./Chevron-right-circle.svg": 55024,
	"./Chevron-right.svg": 4165,
	"./Content.svg": 23386,
	"./Copy.svg": 26481,
	"./Download.svg": 54430,
	"./Edit.svg": 25650,
	"./Exit.svg": 26843,
	"./Featured Resources-1.svg": 22906,
	"./Featured Resources.svg": 10801,
	"./Filter.svg": 15856,
	"./Happy.svg": 90720,
	"./Heart.svg": 68709,
	"./Link.svg": 75727,
	"./Newsagency.svg": 18866,
	"./Newspaper.svg": 11738,
	"./Newspapre.svg": 75962,
	"./Newssite.svg": 75372,
	"./Newsstand.svg": 88706,
	"./Notification.svg": 46631,
	"./Pause.svg": 31954,
	"./Play.svg": 17819,
	"./Plus.svg": 29171,
	"./Pocker.svg": 86722,
	"./Sad.svg": 14006,
	"./Search-1.svg": 93462,
	"./Send.svg": 69973,
	"./Setting.svg": 1170,
	"./Stats.svg": 62621,
	"./Subjects.svg": 78490,
	"./Trash.svg": 13829,
	"./Upload.svg": 76261,
	"./Virasty.svg": 25775,
	"./alarm-icon.svg": 18895,
	"./arrow-down.svg": 24746,
	"./arrow-left-2.svg": 19342,
	"./arrow-left.svg": 81833,
	"./arrow-right-2.svg": 92566,
	"./asd.svg": 29607,
	"./bale-colored.png": 40150,
	"./bale-colored.svg": 97566,
	"./bale-line-active.svg": 61719,
	"./bale-line-inactive.svg": 14119,
	"./bale-line.svg": 26192,
	"./bale.svg": 35941,
	"./cafeBazaar-line-active.svg": 27290,
	"./close.svg": 50420,
	"./colored-still-stars.png": 33312,
	"./comment.svg": 45184,
	"./customer-label-crown.svg": 52906,
	"./customer-label-cup.svg": 97385,
	"./customer-label-run.svg": 29373,
	"./download-paper.svg": 76423,
	"./effective.svg": 82080,
	"./eitaa-colored.png": 9658,
	"./eitaa-colored.svg": 38055,
	"./eitaa-line-active.svg": 6500,
	"./eitaa-line-inactive.svg": 57072,
	"./eitaa-line.svg": 88541,
	"./eitaa.svg": 86216,
	"./emotion-not-sure.svg": 66925,
	"./eye.svg": 45564,
	"./file-forbid-line2.svg": 72778,
	"./filters.svg": 89875,
	"./global-line.svg": 87784,
	"./header-logo.svg": 80586,
	"./image.svg": 1482,
	"./img+vid.svg": 73126,
	"./instagram.svg": 60673,
	"./keyboard-line.svg": 22771,
	"./like.svg": 40685,
	"./linkedin.svg": 78500,
	"./microphone.svg": 32834,
	"./minus.svg": 4475,
	"./more.svg": 74041,
	"./news.svg": 70425,
	"./no-data-found.svg": 93693,
	"./no-pic.svg": 96151,
	"./note.svg": 53220,
	"./question-answer.svg": 72174,
	"./question.svg": 47435,
	"./refresh.svg": 39525,
	"./reshare-1.svg": 60091,
	"./reshare.svg": 93297,
	"./retweet.svg": 84006,
	"./rubika-colored.png": 77454,
	"./rubika-colored.svg": 86076,
	"./rubika-line-active.svg": 31589,
	"./rubika-line-inactive.svg": 53706,
	"./rubika-line.svg": 1768,
	"./rubika.svg": 56705,
	"./search.svg": 79262,
	"./share.svg": 63906,
	"./similar.svg": 80175,
	"./soroush-colored.svg": 79669,
	"./soroush.svg": 49717,
	"./special.svg": 63994,
	"./specific.svg": 69922,
	"./speed-fill.svg": 1189,
	"./speed-up-fill.svg": 40761,
	"./stars.svg": 57129,
	"./starsColor.svg": 33557,
	"./tag.svg": 95084,
	"./telegram.svg": 24588,
	"./telegramGroups.svg": 40522,
	"./telegramGroupsGray.svg": 22032,
	"./twitter.svg": 83961,
	"./twitterIcon.svg": 83244,
	"./video.svg": 63340,
	"./virasty-line-active.svg": 64553,
	"./virasty-line-inactive.svg": 65531,
	"./virasty-line.svg": 32127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;